import Model from "./base/model";

class QuotationModality extends Model{
  resourceName() {
    return "quotation_modalities";
  }

  fields() {
    return {
      type: "",
      value: "",
      reason: "",
    }
  }
}

export default new QuotationModality();
